<template>
  <div class="lk-404">
    <div class="container">
      <h1>
        404
      </h1>
      <h2 style="font-weight: normal">
        Страница "{{ $route.path }}" не найдена
      </h2>
      <hr class="horizontal-line" />
      <router-link to="/finance">Вернуться на главную</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "NotFoundPage"
};
</script>
<style scoped>
.lk-404 {
  height: 100vh;
  width: 100vw;
  background-color: #222d44;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lk-404 .container {
  color: white;
  width: 350px;
  padding: 25px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
